import {
  Image,
  Card,
  CardBody,
  Heading,
  SimpleGrid,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Box,
  Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import { IoIosClose } from "react-icons/io";
import LandingContent from "../../components/landing-content";
import { siteConfig } from "../../configuration/config";
import { getLanguagePages } from "../../server/get-language-pages";

interface PostMeta {
  params: {
    id: string;
    title: string;
    image: string;
  };
}

export default function Languages(props: { posts: PostMeta[] }) {
  const [posts, setPosts] = useState(props.posts);
  const [searchText, setSearchText] = useState("");

  const onChange = (text: string) => {
    setSearchText(text);
    setPosts((p) => {
      if (text === "") {
        return props.posts;
      }

      return props.posts.filter((post) =>
        post.params.title.toLowerCase().includes(text.toLowerCase()),
      );
    });
  };

  const onClear = () => {
    setPosts(props.posts);
    setSearchText("");
  };

  return (
    <LandingContent>
      <Heading mb={3} size="md" as="h1">
        Languages
      </Heading>

      <Text mb={10} as="h2" fontSize="xl">
        Explore the comprehensive overview of the languages we support
      </Text>

      <InputGroup w={{ base: "100%", md: "800px" }} mb={5}>
        <Input
          value={searchText}
          placeholder="Search language"
          onChange={(e) => onChange(e.target.value)}
        />
        {searchText?.length > 0 && (
          <InputRightElement>
            <IconButton
              colorScheme={"transparent"}
              color="#000"
              fontSize="lg"
              aria-label="Clear"
              icon={<IoIosClose />}
              onClick={onClear}
            />
          </InputRightElement>
        )}
      </InputGroup>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4}>
        {posts.length === 0 ? (
          <>
            <Box></Box>
            <Flex minH="300px" m="0 auto" alignItems={"center"} justifyContent="center">
              <Text>No languages</Text>
            </Flex>
            <Box></Box>
          </>
        ) : (
          posts.map((post, i) => (
            <Card
              direction={{ base: "column" }}
              overflow="hidden"
              variant="outline"
              size="sm"
              key={i}
              as="a"
              href={`/languages/${post.params.id}`}
              alignItems={"center"}
            >
              <Image
                objectFit="cover"
                maxW={{ base: "100%", sm: "200px" }}
                w="200px"
                h="150px"
                mt={5}
                mb={{ base: 5, sm: 0 }}
                src={post.params.image}
                alt={post.params.title}
              />

              <CardBody data-id="card-body" pt={0}>
                <Heading size="2xs" p={2} mt={2}>
                  {post.params.title}
                </Heading>
              </CardBody>
            </Card>
          ))
        )}
      </SimpleGrid>
    </LandingContent>
  );
}

export async function getStaticProps() {
  return {
    props: {
      posts: siteConfig.isDefault ? getLanguagePages() : [],
    },
  };
}
